import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

declare const Plyr: any;

@IonicPage()
@Component({
  selector: 'page-video-player',
  templateUrl: 'video-player.html',
})
export class VideoPlayerPage  implements AfterViewInit, OnDestroy {

  material: any;
  isLoading: boolean;
  isPlaying: boolean;
  @ViewChild('videoPlayer') videoPlayer: ElementRef;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public screenOrientation: ScreenOrientation,
  ) {
    this.material = this.navParams.get('material');
    this.isLoading = false;
    this.isPlaying = false;
  }

  ngAfterViewInit(): void {
    const elem = this.videoPlayer.nativeElement;
    elem.load();

    elem.oncanplay = () => {
      const player = new Plyr(this.videoPlayer.nativeElement, {
        // autoplay: true,
        // fullscreen: {
        //   enabled: false,
        //   iosNative: true
        // },
        storage: {
          enabled: false
        }
      });

      player.play();

      player.on('play', _ => {
        this.handleOrientations(elem.videoWidth, elem.videoHeight);
        player.fullscreen.enter();
      });
      
      player.on('enterfullscreen', _ => {
        this.handleOrientations(elem.videoWidth, elem.videoHeight);
        player.fullscreen.enter();
      });

      player.on('exitfullscreen', _ => {
        player.pause();
        this.screenOrientation.unlock();
      });
    }
  }

  handleOrientations(videoWidth, videoHeight) {
    if(videoWidth < videoHeight ) {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
    } else {
      this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
    }
  }


  ngOnDestroy(): void {
    this.screenOrientation.unlock();
  }

  ionViewDidLoad() {
  }

  play() {
    this.isLoading = true;
    const elem = this.videoPlayer.nativeElement;

    elem.load();

    elem.onloadstart = () => {
      // console.log("Starting to load video");
    };
    
    elem.onpause = () => {
      this.isLoading = false;
      this.isPlaying = false;
    };
  
    elem.onplay = () => {
      this.isLoading = true;
      this.isPlaying = true;
    };
    
    elem.oncanplay = () => {
      setTimeout( _ => {
        this.isLoading = false;
        elem.play();
      }, 1000 );
    };
  }

  close() {
    // this.isLoading = false;
    // this.material = null;

    this.navCtrl.pop();
    this.screenOrientation.unlock();
  }

}



// WEBPACK FOOTER //
// ./src/pages/video-player/video-player.ts